import { render, staticRenderFns } from "./PdfThumbnail.vue?vue&type=template&id=805e0496&scoped=true"
import script from "./PdfThumbnail.vue?vue&type=script&lang=js"
export * from "./PdfThumbnail.vue?vue&type=script&lang=js"
import style0 from "./PdfThumbnail.vue?vue&type=style&index=0&id=805e0496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805e0496",
  null
  
)

export default component.exports